// extracted by extract-css-chunks-webpack-plugin
module.exports = {"expenseCalculatorInput":"LxyUJS","holder":"_3GUuOE","inputBox":"_3TZZR9","currencyBox":"_2pqlS6","infoBtn":"_18An7a","iconWrapper":"_3hQRJ2"};